import { useCallback, useState } from 'react';
import { normalizeSynonymDrafts } from '../utils';

type UseSynonymsEditDialogParams = {
  open: boolean;
  initialSynonyms: string[];
  onApply: (synonyms: string[]) => void | Promise<void>;
  onClose: () => void;
};

export function useSynonymsEditDialog({
  initialSynonyms,
  onApply,
  onClose,
}: UseSynonymsEditDialogParams) {
  const [drafts, setDrafts] = useState<string[]>(() =>
    initialSynonyms.length > 0 ? [...initialSynonyms] : [''],
  );
  const [saving, setSaving] = useState(false);

  const handleChange = useCallback((index: number, value: string) => {
    setDrafts((prev) => prev.map((item, i) => (i === index ? value : item)));
  }, []);

  const handleAdd = useCallback(() => {
    setDrafts((prev) => [...prev, '']);
  }, []);

  const handleRemove = useCallback((index: number) => {
    setDrafts((prev) => {
      if (prev.length <= 1) return [''];
      return prev.filter((_, i) => i !== index);
    });
  }, []);

  const handleOk = useCallback(async () => {
    setSaving(true);
    try {
      await onApply(normalizeSynonymDrafts(drafts));
      onClose();
    } finally {
      setSaving(false);
    }
  }, [drafts, onApply, onClose]);

  return {
    drafts,
    saving,
    handleChange,
    handleAdd,
    handleRemove,
    handleOk,
  };
}
